import React from 'react'
import { Col, Nav, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"


export default function SubMenuSchool({ section, school, schoolId }) {
    const { t } = useTranslation()

    return (
        <>
            <Row className='my-3'>
                <Col xs={12} md={9}>
                    <Link to="/multischool/schools" className='link-dark'>
                        <div className='py-3 d-flex align-items-center'>
                            <img src="/images/left-arrow.svg" alt="Flecha izquierda" />
                            <h3 className='ms-3 m-0'>{school?.name}</h3>
                        </div>
                    </Link>
                </Col>
            </Row>
            <Row className='mt-3 mb-5'>
                <Col>
                    <Nav defaultActiveKey="/generalData" as="ul" className='selection-submenu'>
                        <Nav.Item as="li">
                            <Nav.Link active={section === "generalData"} as={Link} to={`/multischool/schools/${schoolId}/edit`}>{t("profile.school.generalData")}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item as="li">
                            <Nav.Link active={section === "schoolStaffs"} as={Link} to={`/multischool/schools/${schoolId}/staff`}>{t("profile.school.schoolStaffs")}</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Col>
            </Row>
        </>
    )
}